// 자주 묻는 질문 하드코딩 데이터
export const faqContent = [
  {
    question: 'Google, Kakao, Naver 각각 다른 계정인가요?',
    answer:
      '네, 각 소셜 로그인은 별도의 계정으로 처리됩니다. 예를 들어 Google로 가입한 후 Kakao로 로그인하면 새로운 계정이 생성됩니다. 처음 가입할 때 사용한 소셜 계정으로 로그인해주세요.',
  },
  {
    question: '게시글이나 사진은 누가 볼 수 있나요?',
    answer:
      '이 앱은 교회 멤버 전용 비공개 커뮤니티입니다. 가입 승인을 받은 멤버만 게시글과 사진을 볼 수 있으며, 외부에 공개되지 않습니다.',
  },
  {
    question: '게시글이나 댓글을 잘못 올렸어요. 삭제할 수 있나요?',
    answer:
      '네, 본인이 작성한 게시글과 댓글은 직접 삭제할 수 있습니다. 게시글 또는 댓글의 수정/삭제 버튼을 눌러주세요. 삭제된 콘텐츠는 관리자가 복구할 수 있습니다.',
  },
  {
    question: '부적절한 게시물을 발견하면 어떻게 하나요?',
    answer:
      '게시글이나 댓글 옆의 깃발 아이콘을 눌러 신고할 수 있습니다. 신고 사유를 선택하면 관리자에게 전달되어 검토 후 조치됩니다.',
  },
  {
    question: '프로필 사진이나 닉네임은 어떻게 변경하나요?',
    answer:
      '마이페이지에서 프로필 사진의 카메라 아이콘을 눌러 사진을 변경하고, 닉네임 옆의 연필 아이콘을 눌러 닉네임을 수정할 수 있습니다.',
  },
  {
    question: '알림이 오지 않아요.',
    answer:
      '기기의 설정에서 앱 알림이 허용되어 있는지 확인해주세요. iOS는 설정 > 알림에서, Android는 설정 > 앱 > 알림에서 확인할 수 있습니다.',
  },
  {
    question: '앱에서 로그아웃하면 데이터가 삭제되나요?',
    answer:
      '아닙니다. 로그아웃해도 게시글, 댓글, 프로필 등 모든 데이터는 그대로 유지됩니다. 다시 같은 소셜 계정으로 로그인하면 이전 상태 그대로 이용할 수 있습니다.',
  },
];
